// extracted by mini-css-extract-plugin
export default {"multiItem":"ModuleMetrics_multiItem__UfiSG"};